// TopMarginDropZone.jsx - Simplified drop zone for top of list
import { DropTarget } from 'react-dnd';
import React from 'react';
import { DragItemTypes } from 'constants/DragConstants';
import MarginDropLine from './MarginDropLine';

const topTarget = {
  drop(props, monitor) {
    const item = monitor.getItem();
    const didDrop = monitor.didDrop();

    if (!didDrop && props.nestCodes) {
      // Always drop at top: parent_id = null, position = 1
      props.nestCodes(item.codeID, null, 1);
      props.endDrag();
    }
  }
};

function collectTarget(connect, monitor) {
  return {
    connectDropTarget: connect.dropTarget(),
    isOver: monitor.isOver({ shallow: true }),
    draggedItem: monitor.getItem(),
  };
}

function TopMarginDropZone(props) {
  const { connectDropTarget, isOver } = props;
  
  // Show line when something is being dragged AND hovering over this zone
  const shouldShow = isOver;

  return connectDropTarget(
    <div style={{
      minHeight: '12px',
      position: 'relative',
      paddingBottom: '4px',
    }}>
      <MarginDropLine
        show={shouldShow}
        canDrop={true} // Always allow drops at top
        depth={0} // Always at root level
        isTop={true} // This is the top zone
      />
    </div>
  );
}

export default DropTarget(DragItemTypes.CODE_LABEL, topTarget, collectTarget)(TopMarginDropZone);